import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Axe";
const Axe = memo(themed(Icon));
export {
  Axe
};
//# sourceMappingURL=axe.js.map
